// routes/single-jobs

import Inputs from "../components/inputs";

export default {
    init() {
        var inputs = new Inputs();
    },
    finalize() {

    }
};



// WEBPACK FOOTER //
// ./js/routes/single-jobs.js